import { use } from 'react';

import { SettingsContext } from './settings-context';

/**
 * Custom hook that provides access to the settings context value.
 *
 * This hook must be used within a SettingsProvider component.
 *
 * @returns The current settings context value
 * @throws {Error} If used outside of a SettingsProvider
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const settings = useSettingsContext();
 *   // Now you can use the settings
 * }
 * ```
 */
export function useSettingsContext() {
    const context = use(SettingsContext);

    if (!context) throw new Error('useSettingsContext must be use inside SettingsProvider');

    return context;
}
